<mat-icon *ngIf="activity; else noActivity" class="spinner">
  donut_large
</mat-icon>

<ng-template #noActivity>
  <span>{{ getLocationDisplayString(location) }}</span>
</ng-template>
